import { useTranslation } from 'react-i18next';
import { X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { Badge } from '@/components/ui/badge';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

export const BedroomFilter = ({ value, onChange, options, resultCount, loading }) => {
  const { t } = useTranslation();
  const active = value !== 'all';

  return (
    <section data-testid="units-bedroom-filter" className="flex flex-wrap items-end gap-3 border-y border-slate-200 py-4">
      <div className="w-full sm:w-64 min-w-0 space-y-2">
        <Label htmlFor="units-bedroom-select">{t('units.bedrooms')}</Label>
        <Select value={value} onValueChange={onChange} disabled={loading}>
          <SelectTrigger id="units-bedroom-select" data-testid="units-bedroom-select" className="w-full">
            <SelectValue />
          </SelectTrigger>
          <SelectContent data-testid="units-bedroom-options">
            <SelectItem data-testid="units-bedroom-option-all" value="all">{t('units.bedroomFilter.allUnits')}</SelectItem>
            {options.map(count => (
              <SelectItem key={count} data-testid={`units-bedroom-option-${count}`} value={String(count)}>
                {t('units.bedroomFilter.bedroomCount', { count })}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      {active && (
        <>
          <div className="flex flex-wrap items-center gap-3 min-h-10">
            <Badge data-testid="units-available-only-badge" variant="outline" className="bg-emerald-50 text-emerald-700 border-emerald-200">
              {t('units.bedroomFilter.availableOnly')}
            </Badge>
            <p data-testid="units-bedroom-result-count" role="status" className="text-sm text-slate-600">
              {t('units.bedroomFilter.results', { count: resultCount })}
            </p>
          </div>
          <Button data-testid="units-bedroom-clear" type="button" variant="ghost" onClick={() => onChange('all')} className="gap-2">
            <X className="w-4 h-4" aria-hidden="true" />
            {t('units.bedroomFilter.clear')}
          </Button>
        </>
      )}
    </section>
  );
};